import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { TabletAndLarger } from '../../shared/responsive-breakpoints'
import HomeRunProfitabilityBanner from './HomeRunProfitabilityBanner'
import HomeRunProfitabilityList from './HomeRunProfitabilityList'

const HomeRunProfitably = ({ runProfitablyData }) => {
  const { header, linkText } = runProfitablyData
  const [activeAccordion, setActiveAccordion] = useState(runProfitablyData.accordions[0].fields)

  const changeActiveAccordion = newAccordion => {
    if (activeAccordion === newAccordion) {
      setActiveAccordion({})
      return
    }
    setActiveAccordion(newAccordion)
  }

  return (
    <section className="dealmed-home-run" aria-labelledby="dealmed-home-run-heading">
      <div className="dealmed-container">
        <h2 className="dealmed-home-run__heading" id="dealmed-home-run-heading">
          {header}
        </h2>
        <div className="dealmed-home-run__wrapper">
          <TabletAndLarger>
            <div className="dealmed-home-run__banner">
              <HomeRunProfitabilityBanner activeAccordion={activeAccordion} />
            </div>
          </TabletAndLarger>
          <div className="dealmed-home-run__accordions">
            <div className="dealmed-container">
              <HomeRunProfitabilityList
                accordions={runProfitablyData.accordions.map(accordion => accordion.fields)}
                activeAccordion={activeAccordion}
                changeActiveAccordion={changeActiveAccordion}
              />
              <Link to={'/about'} className="dealmed-home-run__philosophy">
                {linkText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeRunProfitably
